import styled from "styled-components";

export const MainContainer = styled.main`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  margin: auto;
  min-height: 100vh;

  justify-content: flex-start;
`;

export const Header = styled.header`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  width: 100%;
  z-index: 5;
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`;

export const Logo = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 50px;
  width: 236px;
  background-image: ${(props) => `url('${props.src}')`};
`;

export const BalanceInfo = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 18px;
  color: #202020;
  line-height: 24px;
  letter-spacing: 0.15px;
  text-align: right;

  .balance-amount {
    margin-bottom: 0;
  }

  .balance-label {
    margin: 0;
  }
`;

export const HeroImage = styled.div`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  aspect-ratio: 4096/2731;
  z-index: 4;
  background-image: ${(props) => `url('${props.src}')`};
`;

export const ContentSection = styled.section`
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 25px;
  width: 100%;
  z-index: 3;
  text-align: center;
  color: #000000;
`;

export const Title = styled.h1`
  font-family: "JLREmericSemiBold", sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  margin: 0;
  width: 100%;
  color: #000000;
`;

export const Description = styled.p`
  font-family: "JLREmericWebExtraLight", sans-serif;
  font-weight: 280;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 0;
  width: 100%;
  color: #6b7280;
`;

export const BlackSection = styled.section`
  background-color: #000000;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  padding: 10px 25px;
  width: 100%;
  z-index: 2;
  text-align: center;
  color: #ffffff;
`;

export const BlackTitle = styled.h2`
  font-family: "JLREmericSemiBold", sans-serif;
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
  margin: 0;
  width: 100%;
  color: #ffffff;
`;

export const BlackDescription = styled.p`
  font-family: "JLREmericWebExtraLight", sans-serif;
  font-weight: 280;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 0;
  width: 100%;
  color: #ffffff;
`;

export const Footer = styled.footer`
  background-color: #000000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  justify-content: center;
  padding: 32px 16px 26px;
  width: 100%;
  z-index: 1;
`;

export const PoweredBySection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const PoweredByText = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #ffffff;
  text-align: center;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  justify-content: center;
`;

export const FooterLogo = styled.div`
  background-size: 127.35% 200%;
  background-position: 51.95% 50%;
  background-repeat: no-repeat;
  height: 38px;
  width: 132px;
  background-image: ${(props) => `url('${props.src}')`};
`;

export const LinksSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const LinkText = styled.div`
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #ffffff;
  text-align: center;
  letter-spacing: 0.5px;
  white-space: nowrap;
`;

export const FormContainer = styled.div`
  max-width: 480px;
  position: absolute;
  background: rgba(0, 0, 0, 0.1) !important;
  height: 100%;
  width: 100%;
  text-align: center;
  z-index: 9999;

  .inner-container {
    position: fixed;
    min-width: 360px;
    max-width: 480px;
    width: 95%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 32px 24px;
    border-radius: 12px;
    background-color: #ffffff;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.9);
  }

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
  }

  .inputs {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .terms {
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: flex-start;
    align-items: flex-start;
    margin: 4px 0;

    span {
      font-family: "JLREmericExtraLight", sans-serif;
      font-weight: 200;
      font-size: 12px;
      line-height: 16px;
      color: #626262;
    }

    button {
      font-family: "JLREmericExtraLight", sans-serif;
      font-weight: 200;
      font-size: 12px;
      line-height: 16px;
      color: #626262;
      text-decoration: underline;
      background: none;
      border: none;
      padding: 0;
      cursor: pointer;
    }

    img,
    a {
      cursor: pointer;
    }

    a {
      color: inherit;
      text-decoration: underline;
    }
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  input[type="text"],
  input[type="tel"] {
    font-size: 16px;
    font-family: "JLREmericExtraLight", sans-serif;
    font-weight: 200;
    border: none;
    outline: none;
    width: 100%;
    color: #202020;
    background-color: transparent;
    padding: 0;
    margin: 0;

    ::placeholder {
      color: #626262;
    }
  }

  input[type="checkbox"] {
    width: 24px;
    height: 24px;
    margin: 0;
    cursor: pointer;
  }

  button {
    justify-content: center;
    align-items: center;
    font-family: "JLREmericExtraLight", sans-serif;
    font-size: 16px;
    font-weight: 200;
    line-height: 24px;
    letter-spacing: 0.15px;
    text-transform: uppercase;
    padding: 16px 40px;
    height: 56px;
    width: 100%;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &.primary {
      background-color: #000000;
      color: #ffffff;
      border: 1px solid #000000;

      &:hover {
        background-color: #333333;
      }
    }

    &.secondary {
      background-color: transparent;
      color: #000000;
      border: 1px solid #000000;

      &:hover {
        background-color: #f5f5f5;
      }
    }

    &:disabled {
      background-color: #cccccc;
      border-color: #cccccc;
      cursor: not-allowed;
      opacity: 0.6;
    }

    &.primary:disabled {
      background-color: #666666;
      color: #ffffff;
    }

    &.secondary:disabled {
      background-color: #f5f5f5;
      color: #999999;
      border-color: #cccccc;
    }
  }

  .error {
    color: #ff0000;
    font-size: 12px;
    margin-top: -16px;
    margin-left: 16px;
  }
`;

export const FormHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const FormTitle = styled.h2`
  font-family: "JLREmericSemiBold", sans-serif;
  font-weight: 600;
  font-size: 24px !important;
  line-height: 28px;
  color: #202020;
  text-align: center;
  width: 100%;
  margin: 0;
`;

export const FormDescription = styled.p`
  font-family: "JLREmericExtraLight", sans-serif;
  font-weight: 200;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.5px;
  color: #202020;
  text-align: center;
  width: 100%;
  margin: 0;
`;

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
`;

export const InputField = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: flex-start;
  padding: 16px;
  position: relative;
  width: 100%;
  border-radius: 8px;
  border: 1px solid #d8d8d9;
  &:focus-within {
    border-color: #000000;
  }
`;

export const InputIcon = styled.div`
  overflow: hidden;
  position: relative;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InputContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  min-height: 1px;
  min-width: 1px;
`;

export const InputPlaceholder = styled.div`
  font-family: "JLREmericExtraLight", sans-serif;
  font-weight: 200;
  font-size: 16px;
  line-height: 24px;
  color: #626262;
  letter-spacing: 0.5px;
  margin: 0;
`;

export const FormFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const TermsSection = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
`;

export const TermsText = styled.div`
  font-family: "JLREmericExtraLight", sans-serif;
  font-weight: 200;
  font-size: 12px;
  line-height: 20px;
  color: #202020;
  letter-spacing: 0.5px;
  flex: 1;

  a {
    text-decoration: underline;
    color: #202020;
    cursor: pointer;

    &:hover {
      text-decoration: none;
    }
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const PrimaryButton = styled.button`
  background-color: #000000;
  display: flex;
  gap: 8px;
  height: 56px;
  align-items: center;
  justify-content: center;
  min-width: 144px;
  padding: 16px 40px;
  position: relative;
  border-radius: 8px;
  width: 310px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #333333;
  }

  &:active {
    background-color: #666666;
  }
`;

export const SecondaryButton = styled.button`
  background-color: transparent;
  display: flex;
  gap: 8px;
  height: 56px;
  align-items: center;
  justify-content: center;
  min-width: 144px;
  padding: 16px 40px;
  position: relative;
  border-radius: 8px;
  width: 310px;
  border: 1px solid #000000;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f5f5f5;
  }

  &:active {
    background-color: #e5e5e5;
  }
`;

export const ButtonText = styled.span`
  font-family: "JLREmericExtraLight", sans-serif;
  font-weight: 200;
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => (props.primary ? "#ffffff" : "#000000")};
  letter-spacing: 0.15px;
  white-space: nowrap;
`;

export const Alert = styled.div`
  max-width: 480px;
  position: absolute;
  background: rgba(0, 0, 0, 0.5);
  height: 100%;
  width: 100%;
  text-align: center;
  z-index: 9999;

  .inner-container {
    position: fixed;
    max-width: 343px;
    width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px 24px;
    border-radius: 6px;
    background-color: #ffffff;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

    .nav {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: -20px;
    }

    p,
    h2,
    .subtitle,
    .info,
    .error {
      font-family: "JLREmericExtraLight", sans-serif;
      font-size: 16px;
      font-style: normal;
      font-weight: 200;
      line-height: normal;
    }

    p,
    h2 {
      color: #202020;
      text-align: center;
    }

    .form,
    .inputs,
    button,
    .form-group {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    input {
      font-size: 16px;
      font-family: "JLREmericExtraLight", sans-serif;
      font-weight: 200;
      ::placeholder {
        font-family: "JLREmericExtraLight", sans-serif;
        color: #626262;
      }

      background-color: #ffffff;
      color: #202020;
      margin-bottom: 16px;
    }

    button {
      justify-content: center;
      align-items: center;
      font-family: "JLREmericExtraLight", sans-serif;
      font-size: 16px;
      font-weight: 200;
      line-height: 24px;
      letter-spacing: 0.15px;
      text-transform: uppercase;
      padding: 16px 40px;
      height: 56px;
      width: 310px;
      border-radius: 8px;
      border: none;
      cursor: pointer;
      transition: background-color 0.2s ease;
      margin: 0 auto;

      &.primary {
        background-color: #000000;
        color: #ffffff;
        border: 1px solid #000000;

        &:hover {
          background-color: #333333;
        }
      }

      &.secondary {
        background-color: transparent;
        color: #000000;
        border: 1px solid #000000;

        &:hover {
          background-color: #f5f5f5;
        }
      }

      &:disabled {
        background-color: #cccccc;
        border-color: #cccccc;
        cursor: not-allowed;
      }
    }

    .logos {
      width: 215px;
      margin: auto;
    }

    .terms {
      display: flex;
      flex-direction: row;
      gap: 8px;
      width: 100%;
      justify-content: center;
      align-items: center;
      margin: 16px 0;

      p {
        text-align: center;
      }

      img,
      a {
        cursor: pointer;
      }
      text-align: center;

      a {
        color: inherit;
        text-decoration: underline;
      }
    }

    .button-group {
      display: flex;
      flex-direction: column;
      gap: 16px;
      width: 100%;
    }

    .error {
      color: #ff0000;
      font-size: 14px;
      margin-top: 8px;
    }
  }
`;

export const PinAlert = styled.div`
  max-width: 480px;
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  height: 100%;
  width: 100%;
  text-align: center;
  z-index: 9999;

  .inner-container {
    position: fixed;
    max-width: 343px;
    width: 90%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px 22px;
    border-radius: 20px;
    background-color: #ffffff;
    z-index: 10000;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

    h3 {
      font-family: "JLREmericSemiBold", sans-serif;
      font-size: 24px;
      font-weight: 600;
      color: #202020;
      margin: 0;
      text-align: center;
    }

    .pin-display {
      font-family: "JLREmericSemiBold", sans-serif;
      font-size: 32px;
      font-weight: 600;
      color: #000000;
      background-color: #f5f5f5;
      padding: 20px 40px;
      border-radius: 12px;
      border: 2px solid #000000;
      letter-spacing: 2px;
    }

    button {
      justify-content: center;
      align-items: center;
      font-family: "JLREmericSemiBold", sans-serif;
      font-size: 16px;
      font-weight: 600;
      text-transform: uppercase;
      padding: 16px 32px;
      background-color: #000000;
      border-radius: 12px;
      border: 1px solid #000000;
      color: #ffffff;
      cursor: pointer;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: #333333;
      }
    }
  }
`;
